import type { Portfolio, PortfolioView } from "@ceo-cmd/shared";

export function PortfolioSelector({
  portfolio,
  view,
  companyId,
  onChange,
  compact,
}: {
  portfolio: Portfolio;
  view: PortfolioView;
  companyId?: string;
  onChange: (next: { view: PortfolioView; companyId?: string }) => void;
  compact?: boolean;
}) {
  const value =
    view === "company"
      ? `company:${companyId ?? portfolio.companies[0]?.id ?? ""}`
      : "group";

  return (
    <label
      className={
        compact
          ? "flex items-center gap-2 text-xs text-muted-foreground"
          : "flex flex-col gap-1 text-sm"
      }
    >
      {!compact && (
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
          Portfolio
        </span>
      )}
      <select
        className="rounded-md border border-border bg-card px-2 py-1.5 text-sm text-foreground"
        value={value}
        onChange={(e) => {
          const v = e.target.value;
          if (v === "group") onChange({ view: "group" });
          else
            onChange({
              view: "company",
              companyId: v.replace("company:", ""),
            });
        }}
      >
        <option value="group">All Companies</option>
        {portfolio.companies.map((c) => (
          <option key={c.id} value={`company:${c.id}`}>
            {c.name}
          </option>
        ))}
      </select>
    </label>
  );
}
